import React, {Component} from 'react';
import connect from "react-redux/es/connect/connect";
import {setCurrentNavPage} from "actions";
import PageHeader from "../../components/common/PageHeader/PageHeader";
import _ from "i18n";
import EventDataTable from "../../components/Admin/EventStats/EventDataTable";
import AppTypeStats from "../../components/Admin/EventStats/AppTypeStats";
import PeriodFilter from "../../components/Filters/EventStats/PeriodFilter";
import SaisonFilter from "../../components/Filters/EventStats/SaisonFilter";
import EventRegistrantLineChart
  from "../../components/Admin/EventStats/EventRegistrantLinechart/EventRegistrantLineChart";
import FacturationStats
  from "../../components/Admin/EventStats/Facturation/FacturationStats";
import PeriodFilterEvent from '../../components/Filters/EventStats/PeriodFilterEvent';



class EventStatisticsPage extends Component {

  componentDidMount() {
    this.props.setCurrentNavPage("STATISTICS");
  }

  render() {

    return (
      <div style={{backgroundColor : '#F4F7F9'}}>
        <PageHeader
          header={_('stats') + ' EVENT'}
          subHeader={_('EN QUELQUES CHIFFRES')}
          icon="STATISTICS_HEADER"
          periodFilter={'true'}
        >
          <div className={'flex items-center'}>
            <PeriodFilterEvent />
            {/* <SaisonFilter/> */}
          </div>
        </PageHeader>
        <div className="event-stats-container">
          <EventRegistrantLineChart/>
          <FacturationStats/>
          {/*<AppTypeStats/>*/}
          <EventDataTable/>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({});

const mapDispatchToProps = {
  setCurrentNavPage,
};

export default connect(mapStateToProps, mapDispatchToProps)(EventStatisticsPage);



// WEBPACK FOOTER //
// ./app/pages/Admin/EventStatisticsPage.js